export default {
  api: "https://commerceapi.io",
  oauth: "https://account.logicbroker.com",
  logos: "https://logicbrokeradx.blob.core.windows.net/logos/",
  clientid: "dev_portal",
  production: true,
  googleAnalytics: 'UA-42285878-2'
};
